import { Form } from "react-router";
import type { PendingInvitation } from "@repo/shared-types";
import { SpacePicture } from "@/components/avatar";
import { Button } from "@/components/ui/button";
import { Item, ItemActions, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "@/components/ui/item";

/**
 * The invitations addressed to the caller, each with Accept and Decline, as
 * the spaces page and the inbox both show them. The page's action answers
 * them (lib/invitations). Nothing when there are none.
 */
export function Invitations({ invitations, busy }: { invitations: PendingInvitation[]; busy: boolean }) {
  if (invitations.length === 0) return null;
  return (
    <div className="space-y-3">
      <h2 className="section-label">Invitations</h2>
      <ul className="space-y-2">
        {invitations.map((invitation) => (
          <li key={invitation.id}>
            <Item variant="outline" className="bg-card">
              <ItemMedia>
                <SpacePicture space={invitation.tenant} />
              </ItemMedia>
              <ItemContent className="min-w-0">
                <ItemTitle className="line-clamp-2 wrap-anywhere">{invitation.tenant.name}</ItemTitle>
                <ItemDescription>invited as {invitation.role}</ItemDescription>
              </ItemContent>
              {/* Two buttons, no default. Joining is always something you
                  chose, never something a link did on your behalf. On a
                  phone they take a line of their own, side by side. */}
              <ItemActions className="w-full sm:w-auto">
                <Form method="post" className="flex-1 sm:flex-none">
                  <input type="hidden" name="intent" value="accept" />
                  <input type="hidden" name="id" value={invitation.id} />
                  <Button type="submit" disabled={busy} className="w-full">
                    Accept
                  </Button>
                </Form>
                <Form method="post" className="flex-1 sm:flex-none">
                  <input type="hidden" name="intent" value="decline" />
                  <input type="hidden" name="id" value={invitation.id} />
                  <Button type="submit" variant="outline" disabled={busy} className="w-full">
                    Decline
                  </Button>
                </Form>
              </ItemActions>
            </Item>
          </li>
        ))}
      </ul>
    </div>
  );
}
